
































import { defineComponent, ref, useRouter } from '@nuxtjs/composition-api';
import useFeatureFlag from '@shared/composables/useFeatureFlag';
import useVehicleManualSearch from '@shared/composables/useVehicleManualSearch';
import useVehiclesSidebar from '@shared/composables/useVehiclesSidebar';
import { VehicleSidebarState } from '@shared/system-constants';
import { UCButtonGroup } from '@shared/ui';

import AMXButton from '~/components/AMXButton.vue';
import SearchResults from '~/components/VehiclesSideBar/SearchResults.vue';
import SidebarHeading from '~/components/VehiclesSideBar/SidebarHeading.vue';
import SidebarSubheading from '~/components/VehiclesSideBar/SidebarSubheading.vue';
import VehicleManualSearchForm from '~/components/VehiclesSideBar/VehiclesManualSearch/VehicleManualSearchForm.vue';

enum ViewState {
  SEARCH,
  RESULTS,
}

export default defineComponent({
  name: 'VehiclesManualSearch',
  components: {
    SearchResults,
    VehicleManualSearchForm,
    SidebarSubheading,
    SidebarHeading,
    AMXButton,
    UCButtonGroup,
  },
  props: {
    showResults: {
      type: Boolean,
      default: null,
    },
  },
  setup(props, { emit }) {
    const { results } = useVehicleManualSearch();
    const { setView } = useVehiclesSidebar();
    const { isFeatureEnabled } = useFeatureFlag();
    const router = useRouter();
    const searchError = ref('');
    const viewState = ref<ViewState>(props.showResults ? ViewState.RESULTS : ViewState.SEARCH);

    const onRegoSearchClicked = () => setView(VehicleSidebarState.REGO_SEARCH);
    const onVINSearchClicked = () => setView(VehicleSidebarState.VIN_SEARCH);
    const onSearchResponse = () => {
      viewState.value = ViewState.RESULTS;
    };
    const onSearchAgainClicked = () => (viewState.value = ViewState.SEARCH);

    const onContactClicked = () => {
      emit('close-sidebar');
      router.push('/pages/contact');
    };

    return {
      viewState,
      ViewState,
      results,
      searchError,
      onRegoSearchClicked,
      onVINSearchClicked,
      onSearchAgainClicked,
      onSearchResponse,
      isFeatureEnabled,
      onContactClicked,
    };
  },
});
